module.exports = __webpack_public_path__ + "img/platformValueRed.53791604.jpg";